import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { useI18n } from "../../i18n";
import { adminGetSettings, adminUpdateSettings } from "../../lib/api";
import { Download, QrCode, Monitor, Check } from "../Icon";

export function ToolsTab() {
  const { t } = useI18n();
  const [qr, setQr] = useState("");
  const wallUrl = `${window.location.origin}/wall`;

  // board settings (shown in minutes, stored in seconds)
  const [cardMin, setCardMin] = useState(3);
  const [wallMin, setWallMin] = useState(2);
  const [cardAdvanceSec, setCardAdvanceSec] = useState(10);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    QRCode.toDataURL(wallUrl, { width: 480, margin: 2 }).then(setQr).catch(() => {});
    adminGetSettings()
      .then((s) => {
        setCardMin(Math.round((s.board_card_seconds / 60) * 10) / 10);
        setWallMin(Math.round((s.board_wall_seconds / 60) * 10) / 10);
        setCardAdvanceSec(s.board_card_advance_seconds);
      })
      .catch(() => {});
  }, [wallUrl]);

  async function saveSettings() {
    setSaved(false);
    await adminUpdateSettings({
      board_card_seconds: Math.max(10, Math.round(cardMin * 60)),
      board_wall_seconds: Math.max(10, Math.round(wallMin * 60)),
      board_card_advance_seconds: Math.max(2, Math.round(cardAdvanceSec)),
    }).catch(() => {});
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  }

  return (
    <div className="grid gap-6 md:grid-cols-2">
      <div className="card text-center">
        <h3 className="inline-flex items-center gap-2 font-bold text-[var(--theme-deep)]">
          <QrCode className="h-5 w-5" /> {t("admin.wallQrTitle")}
        </h3>
        <p className="mt-1 text-sm text-ink/60">{t("admin.wallQrDesc")}</p>
        {qr && <img src={qr} alt="Wall QR" className="mx-auto mt-4 h-56 w-56 rounded-xl ring-1 ring-black/[0.06]" />}
        <div className="mt-2 break-all text-xs text-ink/45">{wallUrl}</div>
        {qr && (
          <a href={qr} download="birthday-wall-qr.png" className="btn-primary mt-4">
            <Download className="h-4 w-4" /> {t("admin.downloadQr")}
          </a>
        )}
      </div>

      <div className="flex flex-col gap-6">
        <div className="card">
          <h3 className="inline-flex items-center gap-2 font-bold text-[var(--theme-deep)]">
            <Monitor className="h-5 w-5" /> {t("admin.boardLink")}
          </h3>
          <a href="/board" target="_blank" rel="noreferrer" className="btn-ghost mt-3">
            <Monitor className="h-4 w-4" /> {t("admin.boardLink")}
          </a>
        </div>

        <div className="card">
          <h3 className="font-bold text-[var(--theme-deep)]">{t("admin.boardSettings")}</h3>
          <p className="mt-1 text-sm text-ink/60">{t("admin.boardSettingsDesc")}</p>
          <div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-3">
            <label className="block">
              <span className="field-label">{t("admin.boardCardMinutes")}</span>
              <input
                type="number"
                min={0.5}
                step={0.5}
                className="field"
                value={cardMin}
                onChange={(e) => setCardMin(Number(e.target.value))}
              />
            </label>
            <label className="block">
              <span className="field-label">{t("admin.boardWallMinutes")}</span>
              <input
                type="number"
                min={0.5}
                step={0.5}
                className="field"
                value={wallMin}
                onChange={(e) => setWallMin(Number(e.target.value))}
              />
            </label>
            <label className="block">
              <span className="field-label">{t("admin.boardCardAdvance")}</span>
              <input
                type="number"
                min={2}
                step={1}
                className="field"
                value={cardAdvanceSec}
                onChange={(e) => setCardAdvanceSec(Number(e.target.value))}
              />
            </label>
          </div>
          <button onClick={saveSettings} className="btn-primary mt-4">
            {saved ? <><Check className="h-4 w-4" /> {t("admin.settingsSaved")}</> : t("admin.saveSettings")}
          </button>
        </div>
      </div>
    </div>
  );
}
